import queryString from "query-string";

import { localCache } from "@js/localCache";
import EventsCenter from "@js/events/index";
import UUID from "@js/uuid";
import Logger from "@js/logger";
import {
  loginKeyName,
  loginAccountIdName,
  loginUserInfoName,
  currentGameInfo,
  gameRunningTime,
  gameNodeInfo,
  loginType,
  selectGameInfo,
  isRTCConnected,
  currentGameUid,
  currentGameNode,
  uuid,
  isPlayingGame,
} from "@/config";

// key
export function setLoginKey(value: string | null): void {
  localCache.setItem(loginKeyName, value, 1);
  EventsCenter.emit(ACCOUNT_EVENTS.LOGIN_SUCCESS, value);

  if (getUUID() && getUUID().length) {
    Logger.log(`uuid exist ${getUUID()}`);
  } else {
    setUUID(UUID.generate());
    Logger.log(`uuid generate ${getUUID()}`);
  }
}

export function getLoginKey(): string {
  const param = queryString.parse(location.search);
  // 临时测试用的判断
  if (param.loginkey && param.loginkey.length) {
    // http://192.168.1.170:8000/game.html?toid=824&loginkey=yungame_test_webrtc&debug=1&datachannel=1
    return param.loginkey as string;
  } else {
    return localCache.getItem(loginKeyName, 1) || "";
  }
}
// account id
export function setAccountId(value: string | any): void {
  localCache.setItem(loginAccountIdName, value, 1);
}

export function getAccountId(): number {
  return localCache.getItem(loginAccountIdName, 1);
}

// isRTCConnected: webrtc是否連接成功
export function setRTCConnected(value: number | null): void {
  localCache.setItem(isRTCConnected, value, 1);
}

export function getRTCConnected(): boolean {
  return localCache.getItem(isRTCConnected, 1) - 0 > 0;
}

// game uid
export function setGameUid(value: string | null): void {
  localCache.setItem(currentGameUid, value, 1);
}

export function getGameUid(): number {
  return localCache.getItem(currentGameUid, 1);
}

export function setCurrentGameNode(value: any): void {
  localCache.setItem(currentGameNode, JSON.stringify(value), 1);
}

export function getCurrentGameNode() {
  return JSON.parse(localCache.getItem(currentGameNode, 1));
}

// 用户信息
export function setUserInfo(value: string | null): void {
  localCache.setItem(loginUserInfoName, value, 1);
}

export function getUserInfo() {
  return localCache.getItem(loginUserInfoName, 1);
}
// 判断是否登录
export function isLogin() {
  return getLoginKey() && getLoginKey().length > 0;
}
// 当前游戏
export function setCurrentGame(game: pro.yunpb.IGameNode | null): void {
  localCache.setItem(currentGameInfo, game, 1);
}

export function getCurrentGame() {
  return localCache.getItem(currentGameInfo, 1);
}
// 选择游戏
export function setSelectGame(game: pro.yunpb.IGameNode | null): void {
  localCache.setItem(selectGameInfo, game, 1);
}

export function getSelectGame() {
  return localCache.getItem(selectGameInfo, 1);
}
// 登录类型
export function setLoginType(val: string | null): void {
  localCache.setItem(loginType, val, 1);
}

export function getLoginType(): string {
  const param = queryString.parse(location.search);
  if (param.type && param.type.indexOf("QQ") > -1) {
    setLoginType("qq");
    return "qq";
  } else if (param.type && param.type.indexOf("WECHAT") > -1) {
    setLoginType("wechat");
    return "wechat";
  }
  return localCache.getItem(loginType, 1);
}
// 判断游戏是否相同
export function gameEqual(
  from: pro.yunpb.IGameNode,
  to: pro.yunpb.IGameBaseInfo
): boolean {
  if (!from || !to) {
    return false;
  }

  return from.name === to.gameName && from.gameId === to.gameId;
}
// 游戏运行时间
export function setGameRunningTime(val: number | null): void {
  localCache.setItem(gameRunningTime, val, 1);
}

export function getGameRunningTime(): string {
  return localCache.getItem(gameRunningTime, 1);
}
// 全部游戏列表
export function setGameNodeInfo(val: object): void {
  localCache.setItem(gameNodeInfo, val, 1);
}

export function getGameNodeInfo(gameId: number): object | null {
  const nodeInfos = localCache.getItem(gameNodeInfo, 1);
  if (nodeInfos && Array.isArray(nodeInfos)) {
    return nodeInfos.find((item) => {
      return item.gameId === gameId;
    });
  }
  return null;
}
// UUID
export function setUUID(val: string | null): void {
  localCache.setItem(uuid, val, 1);
}

export function getUUID(): string {
  return localCache.getItem(uuid, 1);
}

export function setIsPlayingGame(val: number | null) {
  localCache.setItem(isPlayingGame, val, 1);
}

export function getIsPlayingGame(): string {
  return localCache.getItem(isPlayingGame, 1);
}

export function clear() {
  setLoginKey(null);
  setAccountId(null);
  setUserInfo(null);
  setCurrentGame(null);
  setSelectGame(null);
  setGameRunningTime(null);
  setGameUid(null);
  setLoginType(null);
  setUUID(null);
  setIsPlayingGame(null);
}

export const ACCOUNT_EVENTS = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
};
